import { Box, styled } from '@mui/material';
import { DARK, GRAY_SECONDARY } from 'constants/colors';
import { AskRoundSettingsResponse } from 'generated/index';
import { useTranslation } from 'react-i18next';

const Label = styled('span')`
  text-transform: none;
  color: ${GRAY_SECONDARY};
  font-size: 14px;
  font-weight: regular;
  line-height: 1.5;
  white-space: nowrap;
`;

const LabelGroup = styled('div')`
  display: flex;
  gap: 4px;
`;

const PhaseMetaData = ({ round }: { round: AskRoundSettingsResponse }) => {
  const { t } = useTranslation('common', { keyPrefix: 'aiMatchSettings' });

  return (
    <Box mr={2} display="flex" flexDirection="column">
      <LabelGroup>
        <Label>{`${t('roundType.hoursBeforeStart')}:`}</Label>
        <Label sx={{ color: DARK }}>
          {round.minutesBeforeStart / 60} {t('hours').toLowerCase()}
        </Label>
      </LabelGroup>
    </Box>
  );
};

export default PhaseMetaData;
